import React from 'react';
import { Icon } from 'antd';
import Btn, { btnTypes } from '../../../../../../../components/btn';

export const iconsPos = {
  left: 'left',
  right: 'right',
};

const GoToBtn = ({ iconPos, text, ...props }) => {
  return (
    <Btn
      {...props}
      type={btnTypes.primaryInvert}
    >
      {iconPos === iconsPos.left && <Icon type="arrow-left" />}
      {text}
      {iconPos === iconsPos.right && <Icon type="arrow-right" />}
    </Btn>
  );
};

export default GoToBtn;
